import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet, useLocation } from 'react-router-dom';
import AppBar from './AppBar';
import PageChrome from './PageChrome';
import Footer from './Footer';
import { useDomainStore } from '@/hooks/useStores';
import './layout.css';

const FAMILY_ROUTE_PATTERN = /^\/families\/([^/]+)/;

const Layout: React.FC = observer(() => {
  const domainStore = useDomainStore();
  const location = useLocation();

  useEffect(() => {
    const match = location.pathname.match(FAMILY_ROUTE_PATTERN);
    if (match && domainStore.familiesMetadata.length === 0) {
      domainStore.loadFamiliesMetadata();
    }
  }, [location.pathname, domainStore]);

  return (
    <div className="layout">
      <div className="layout__chrome" data-tour="appbar-family-nav">
        <AppBar />
        <div className="brand-stripe" aria-hidden />
      </div>

      <main className="layout__main">
        <PageChrome />
        <Outlet />
      </main>

      <Footer />
    </div>
  );
});

export default Layout;
